import { useLanguageFromPath } from "plos/src/hooks/useLanguageFromPath";
import { localizePath } from "plos/src/utils/language";
import { forwardRef } from "react";
import { NavLink } from "react-router";
import { subNavStyles } from "../GameHeader/Nav/Nav.css";
import { navItemStyles } from "../GameHeader/Nav/NavItem/NavItem.css";
import { activeSubNavLinkStyles, subNavLinkStyles } from "./subNav.css";

export interface SubNavLink {
  href: string;
  text: string;
  exact?: boolean;
}

interface SubNavItemProps extends SubNavLink {}

const SubNavItem = forwardRef<HTMLLIElement, SubNavItemProps>(
  ({ text, href, exact = false }, ref) => {
    const lang = useLanguageFromPath();
    const localizedHref = localizePath(href, lang);

    return (
      <li className={navItemStyles} ref={ref}>
        <NavLink
          className={({ isActive }) =>
            `${subNavLinkStyles} ${isActive ? activeSubNavLinkStyles : ""}`
          }
          to={localizedHref}
          end={exact}
        >
          {text}
        </NavLink>
      </li>
    );
  },
);

interface SubNavProps {
  links: SubNavLink[];
}

const SubNav = ({ links }: SubNavProps) => (
  <ul className={subNavStyles}>
    {links.map((link) => (
      <SubNavItem {...link} key={link.href} />
    ))}
  </ul>
);

export default SubNav;
